import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { OutingIteration } from 'src/app/outing/outing-iteration';
import { OutingIterationService } from 'src/app/outing/outing-iteration.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { CourseService } from '../../course/course.service';
import { Course } from '../../course/course';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-outing-iteration-edit',
    templateUrl: './outing-iteration-edit.component.html',
    styleUrls: ['./outing-iteration-edit.component.scss'],
    standalone: false
})
export class OutingIterationEditComponent extends BaseComponent implements OnInit {

  public canEditIteration: boolean = true;
  public id: string;
  public outingIteration: OutingIteration;
  public courses: Course[] = [];

  public form = new FormGroup({
    id: new FormControl(''),
    startDate: new FormControl('',{
      validators: Validators.required
    }),
    cost: new FormControl('',{
      validators: Validators.required
    }),
    creditCardFee: new FormControl(''),
    registrationCode: new FormControl('',{
      validators: Validators.required
    })
  });


  constructor(sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private outingIterationService: OutingIterationService,
    private courseService: CourseService,
    stringHelpers: StringHelpers
  ) {
    super(sessionService, stringHelpers);
   }

  ngOnInit(): void {
    if(this.isGlobalOutingSet()){
      this.selectedIteration = this.getGlobalOutingIteration();
      this.id = this.route.snapshot.paramMap.get('id');
      this.form.get('id').patchValue(this.id);
      this.getIteration();
    }
  }

  getIteration(){
    this.isLoading = true;
    this.outingIterationService.getById(this.id).subscribe({
      next: (result) => {
        this.outingIteration = result;
        this.form.patchValue(result);
        const startDate = new Date(result.startDate);
        const currentDate = new Date();
        this.canEditIteration = startDate > currentDate;
        this.updateFormReadOnlyState();
        this.getCourses();
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      }
    });
  }

  private updateFormReadOnlyState(): void {
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      if (!this.canEditIteration) {
        control.disable();
      } else {
        control.enable();
      }
    });
  }

  getCourses(){
    this.courseService.getCoursesByState({ state: "MI" }).subscribe({
      next: (result: any) => {
        this.courses = result.results;
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      },
      complete: () => this.isLoading = false
    });

  }

  onSubmit({ value, valid }){
    if(valid){
      value.lastEditedBy = this.getUserIdFromSession();
      this.outingIterationService.update(value).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['administration', 'outing', 'iteration', 'details', this.id]);
        },
        error: (error) => {
          this.isLoading = false;
          console.log(error);
        },
      })
    }
  }
}
